"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SetRuleCmd = exports.PrjStatusCmd = exports.GeneralNewCmd = exports.GeneralCadCmd = exports.ActionV2 = exports.Action = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _ = require("..");
var SetRuleCmd = /*#__PURE__*/function () {
  function SetRuleCmd(row, rule) {
    var placerIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
    (0, _classCallCheck2["default"])(this, SetRuleCmd);
    this.rule = rule;
    this.row = row;
    this.prevRowStatus = row.createMemento();
  }
  (0, _createClass2["default"])(SetRuleCmd, [{
    key: "execute",
    value: function execute() {
      this.row.setRule(this.rule);
    }
  }, {
    key: "unexecute",
    value: function unexecute() {
      var rule = new _.Rule(this.prevRowStatus.getState().rule);
      console.log(rule.reg);
      this.row.setRule(rule);
    }
  }]);
  return SetRuleCmd;
}();
exports.SetRuleCmd = SetRuleCmd;
var PrjStatusCmd = /*#__PURE__*/function () {
  function PrjStatusCmd(prevMmn, prj) {
    (0, _classCallCheck2["default"])(this, PrjStatusCmd);
    this.prevStatus = prevMmn;
    this.project = prj;
  }
  (0, _createClass2["default"])(PrjStatusCmd, [{
    key: "setProject",
    value: function setProject(prj) {
      this.project = prj;
      this.status = this.project.createMemento();
    }
  }, {
    key: "execute",
    value: function execute() {
      var action = new Action();
      action.setPrj(this.prevStatus, this.project);
      console.error("Implement promise in PrjStatusCmd");
      return null;
    }
  }]);
  return PrjStatusCmd;
}();
exports.PrjStatusCmd = PrjStatusCmd;
var GeneralCadCmd = /*#__PURE__*/function () {
  function GeneralCadCmd(nextPage, vueComp, prj, cad, bus) {
    (0, _classCallCheck2["default"])(this, GeneralCadCmd);
    this.nextPage = nextPage;
    this.vueComp = vueComp;
    this.prj = prj;
    this.prjStatus = this.prj !== null ? this.prj.createMemento() : null;
    this.cad = cad;
    this.cadStatus = this.cad !== null ? cad.getState() : null;
    this.bus = bus;
    var xThis = this;
    this.progressCb = function (progress, total) {};
    this.progressEndCb = function () {
      if (xThis.bus) xThis.bus.$emit("stopLoading");
    };
  }
  (0, _createClass2["default"])(GeneralCadCmd, [{
    key: "execute",
    value: function execute() {
      var _this = this;
      return new _promise["default"](function (resolve, reject) {
        try {
          var action = new Action();
          if (_this.prj !== null) action.setPrj(_this.prjStatus, _this.prj);
          if (_this.prj !== null && _this.cad !== null) action.setCad(_this.cadStatus, _this.cad, _this.prj, _this.progressCb);
          var redraw = !_this.cadStatus.clonedShared.clonedClosetIstance && (_this.vueComp === null || _this.vueComp && _this.vueComp.mode && _this.vueComp.mode == _this.nextPage);
          action.changePage(_this.nextPage, _this.vueComp);
          resolve(redraw);
        } catch (error) {
          reject(error);
        }
      });
    }
  }]);
  return GeneralCadCmd;
}();
exports.GeneralCadCmd = GeneralCadCmd;
var GeneralNewCmd = /*#__PURE__*/function () {
  function GeneralNewCmd(_ref) {
    var nextPage = _ref.nextPage,
      vueComp = _ref.vueComp,
      prj = _ref.prj,
      cad = _ref.cad,
      bus = _ref.bus;
    (0, _classCallCheck2["default"])(this, GeneralNewCmd);
    this.nextPage = nextPage;
    this.vueComp = vueComp;
    this.prj = prj;
    this.prjStatus = this.prj !== null ? this.prj.createMemento() : null;
    this.cad = cad;
    this.cadStatus = this.cad !== null ? cad.getState() : null;
    this.bus = bus;
    var xThis = this;
    this.progressCb = function (progress, total) {};
    this.progressEndCb = function () {
      if (xThis.bus) xThis.bus.$emit("stopLoading");
    };
  }
  (0, _createClass2["default"])(GeneralNewCmd, [{
    key: "execute",
    value: function execute() {
      var _this2 = this;
      return new _promise["default"](function (resolve, reject) {
        try {
          var action = new ActionV2();
          if (_this2.prj !== null) action.setPrj(_this2.prjStatus, _this2.prj);
          if (_this2.prj !== null && _this2.cad !== null) action.setCad(_this2.cadStatus, _this2.cad, _this2.prj, _this2.progressCb);
          var redraw = !_this2.cadStatus.clonedShared.clonedClosetIstance && (_this2.vueComp === null || _this2.vueComp && _this2.vueComp.$route.path && _this2.vueComp.$route.path == _this2.nextPage);
          action.changePage(_this2.nextPage, _this2.vueComp);
          resolve(redraw);
        } catch (error) {
          reject(error);
        }
      });
    }
  }]);
  return GeneralNewCmd;
}();
exports.GeneralNewCmd = GeneralNewCmd;
var Action = /*#__PURE__*/function () {
  function Action() {
    (0, _classCallCheck2["default"])(this, Action);
  }
  (0, _createClass2["default"])(Action, [{
    key: "setPrj",
    value: function setPrj(status, prj) {
      if (!status) throw new Error('Missing project status');
      if (!prj) throw new Error('Missing project');
      prj.setStatus(status.getState());
    }
  }, {
    key: "changePage",
    value: function changePage(page, vueComp) {
      if (vueComp) vueComp.mode = page;
    }
  }, {
    key: "setCad",
    value: function setCad(st, iCad, prj, progress) {
      return iCad.setState(prj, st, progress);
    }
  }]);
  return Action;
}();
exports.Action = Action;
var ActionV2 = /*#__PURE__*/function (_Action) {
  (0, _inherits2["default"])(ActionV2, _Action);
  var _super = (0, _createSuper2["default"])(ActionV2);
  function ActionV2() {
    (0, _classCallCheck2["default"])(this, ActionV2);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(ActionV2, [{
    key: "changePage",
    value: function changePage(page, vueComp) {
      if (vueComp && vueComp.$route.path != page) vueComp.$router.replace({
        path: page
      });
    }
  }]);
  return ActionV2;
}(Action);
exports.ActionV2 = ActionV2;
//# sourceMappingURL=CadCommands.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/CadCommands.js
// module id = 1242
// module chunks = 142